import { useState } from "react";

export interface AccordionItemData {
  question: string;
  answer: string;
}

interface AccordionProps {
  items: AccordionItemData[];
}

export default function Accordion({ items }: AccordionProps) {
  const [open, setOpen] = useState<number[]>([0]);

  const toggle = (index: number) => {
    setOpen((prev) =>
      prev.includes(index) ? prev.filter((item) => item !== index) : [...prev, index],
    );
  };

  return (
    <div className="relative divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/70 to-transparent"
        aria-hidden="true"
      />
      {items.map((item, index) => {
        const isOpen = open.includes(index);
        return (
          <div key={item.question}>
            <h3>
              <button
                type="button"
                onClick={() => toggle(index)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-start justify-between gap-6 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-7"
              >
                <span className="font-heading text-base font-medium text-foreground-950 md:text-lg">
                  {item.question}
                </span>
                <span
                  className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                    isOpen
                      ? "border-accent-500 bg-accent-500 text-foreground-950"
                      : "border-background-300 text-foreground-600"
                  }`}
                  aria-hidden="true"
                >
                  <i className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"} />
                </span>
              </button>
            </h3>
            <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 pb-6 text-sm leading-relaxed text-foreground-600 md:px-7 md:text-[15px]">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}